import React, { useState } from "react";
import ActiveFormModal from "./ActiveFormModal";
import AdminSubCateEditModal from "./AdminSubCateEditModal";
import defaultimg from "../assets/img/dummy.jpeg";
import {
  getAllSubCategories,
  updateSubCategoriesById,
} from "../actions/subCategories";
import { useDispatch } from "react-redux";
// import AdminGeneralEditModal from "./AdminGeneralEditModal";
// import AdminCateEditModal from "./AdminCateEditModal";

const AdminSubCateListRow = ({ current, i, matchingCategory }) => {
  const [showEditSubCategoryModal, setshowEditSubCategoryModal] =
    useState(false);
  const openEditSubCategoryModal = () => {
    setshowEditSubCategoryModal(
      (showEditSubCategoryModal) => !showEditSubCategoryModal
    );
  };
  const [showActiveModal, setshowActiveModal] = useState(false);
  const openActiveModal = () => {
    setshowActiveModal((showActiveModal) => !showActiveModal);
  };
  const dispatch = useDispatch();
  // const [values, setValues] = useState({
  //   _id: "",
  //   status: "",
  // });
  const handleSubmit = async (event) => {
    console.log("handleSubmit modal k bhr");

    event.preventDefault();
    const updatedStatus = !current.status; // Toggle the boolean value
    const statusData = {
      _id: current.id,
      status: updatedStatus, // Assign the toggled value
    };
    dispatch(updateSubCategoriesById(statusData));

    setTimeout(() => {
      dispatch(getAllSubCategories());
    }, 1000);
    setshowActiveModal(false);
  };

  console.log(current, "currenttttttt modal k bhr");
  return (
    <>
      <tr>
        <td>{i + 1}</td>
        <td>
          <img
            src={
              current?.profilePic?.fileUrl
                ? current?.profilePic?.fileUrl
                : defaultimg
            }
            alt="Category Image"
            // style={{ width: "40", height: "40" }}
            className="default-pic-height rounded border"
          />
        </td>
        <td>{current.name}</td>
        <td>{matchingCategory ? matchingCategory.name : "-"}</td>
        <td>
          {current.status === true ? (
            <a
              href="#"
              className="btn btn-sm btn-success"
              onClick={openActiveModal}
            >
              Active
            </a>
          ) : (
            <a
              href="#"
              className="btn btn-sm btn-dark"
              onClick={openActiveModal}
            >
              Deactivated
            </a>
          )}
          <a
            href="#"
            className="btn btn-sm btn-primary mx-1"
            onClick={openEditSubCategoryModal}
          >
            Edit
          </a>
          <a href="#" className="btn btn-sm btn-danger">
            Delete
          </a>
        </td>
      </tr>
      <ActiveFormModal
        openActiveModal={openActiveModal}
        showActiveModal={showActiveModal}
        current={current}
        handleSubmit={handleSubmit}
      />
      <AdminSubCateEditModal
        openEditSubCategoryModal={openEditSubCategoryModal}
        showEditSubCategoryModal={showEditSubCategoryModal}
        current={current}
        matchingCategory={matchingCategory}
      />
    </>
  );
};

export default AdminSubCateListRow;
